import { Skeleton } from "./Skeleton"

/**
 * PositionCardSkeleton - Skeleton for EnhancedPositionCard
 *
 * Matches EnhancedPositionCard active layout:
 * - p-3 sm:p-4 padding
 * - gap-3 between elements
 * - size-8 avatar (32px) with rounded-md (SimpleAvatar sm + square)
 * - rounded-xl card
 * - Desktop: 3 metric columns (Avg w-16, Current w-16, Value w-28) + w-10 spacer
 * - Mobile: only Value/P&L visible
 */
export function PositionCardSkeleton() {
	return (
		<output
			aria-busy="true"
			className="block rounded-xl border border-border-subtle bg-bg-card p-3 sm:p-4"
		>
			<span className="sr-only">Loading position…</span>
			<div className="flex items-center gap-3">
				{/* Avatar: size-8 (32px) square with rounded-md - matches SimpleAvatar size="sm" variant="square" */}
				<Skeleton className="size-8 shrink-0 rounded-md" />

				{/* Content */}
				<div className="min-w-0 flex-1">
					{/* Name: font-medium text-sm = h-5 */}
					<Skeleton className="h-5 w-28" />
					{/* Details: text-xs = h-4 (outcome + shares at price) */}
					<Skeleton className="mt-1 h-4 w-36" />
				</div>

				{/* Desktop: Avg, Current, Value columns (hidden on mobile) */}
				<div className="hidden items-center gap-3 sm:flex">
					{/* Avg: w-16 */}
					<div className="w-16 text-right">
						<Skeleton className="ml-auto h-5 w-10" />
					</div>
					{/* Current: w-16 */}
					<div className="w-16 text-right">
						<Skeleton className="ml-auto h-5 w-10" />
					</div>
					{/* Value + P&L: w-28 */}
					<div className="w-28 text-right">
						<Skeleton className="ml-auto h-5 w-16" />
						<Skeleton className="mt-0.5 ml-auto h-4 w-20" />
					</div>
				</div>

				{/* Mobile: Value + P&L only */}
				<div className="shrink-0 text-right sm:hidden">
					<Skeleton className="ml-auto h-5 w-14" />
					<Skeleton className="mt-0.5 ml-auto h-4 w-12" />
				</div>

				{/* Action spacer for alignment with closed positions */}
				<div className="hidden w-10 shrink-0 sm:block" />
			</div>
		</output>
	)
}
